export default __webpack_public_path__ + "static/partnerIcon20-16b13e5d492873dd51e8f347eed53ff7.svg";